<template>
  <!-- tailwindcssは動きません。eruda.client.tsにcssを定義しています。 -->
  <div class="navipark-container">
    <div class="navipark-title">🅿 NaviPark開発者ツール</div>

    <div class="navipark-input-group">
      <div class="navipark-head2">現在のURL</div>
      <div class="navipark-url-display">{{ currentUrl }}</div>
      <button class="navipark-button navipark-button-small" @click="copyUrl">
        URLをコピー
      </button>
    </div>

    <div class="navipark-input-group">
      <div class="navipark-head2">クイック遷移</div>
      <div class="flex gap-4">
        <button
          class="navipark-button navipark-button-small"
          @click="router.replace('/')"
        >
          トップ
        </button>
        <button
          class="navipark-button navipark-button-small"
          @click="router.replace('/monthly')"
        >
          貸出契約一覧
        </button>
      </div>
    </div>

    <div class="navipark-input-group">
      <div class="navipark-head2">仮申込へ遷移する</div>
      <label for="parking-id-input" class="navipark-label">
        駐車場ID (parkingId)
      </label>
      <input
        id="parking-id-input"
        v-model="parkingId"
        type="text"
        class="navipark-input"
        placeholder="例: 12345"
        @keypress="handleKeypress"
      />
    </div>
    <button class="navipark-button" @click="navigateToPreapplication">
      仮申込へ遷移する
    </button>
  </div>
</template>
<script setup lang="ts">
  const route = useRoute();
  const parkingId = ref('');
  const router = useRouter();

  const currentUrl = computed(() => {
    return window.location.origin + route.fullPath;
  });

  const copyUrl = () => {
    navigator.clipboard.writeText(currentUrl.value).then(() => {
      alert('URLをコピーしました');
    });
  };

  const navigateToPreapplication = () => {
    console.log('Navigate button clicked');
    const id = parkingId.value.trim();
    if (id) {
      const targetUrl = `/monthly/preapplication/${id}`;
      console.log(`Navigating to: ${targetUrl}`);
      window.location.href = targetUrl;
    } else {
      alert('駐車場IDを入力してください');
    }
  };

  const handleKeypress = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      navigateToPreapplication();
    }
  };
</script>
